// import React from "react";
// import { Element } from "react-scroll";
// import ScrollAnimation from "react-animate-on-scroll";
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
// } from "@/components/ui/card";

// const servicesData = [
//   {
//     title: "Mock Tests",
//     description: "Prepare for exams with our comprehensive mock tests tailored for various fields.",
//     icon: "📝",
//     link: "/mock",
//   },
//   {
//     title: "Career Counselling",
//     description: "Receive expert guidance to navigate your career path, job opportunities, and career planning.",
//     icon: "🎓",
//     link: "/career-assessment",
//   },
//   {
//     title: "Study Abroad Options",
//     description: "Explore global educational opportunities with our support for studying abroad.",
//     icon: "🌍",
//     link: "/study-abroad",
//   },
//   {
//     title: "E-Learning",
//     description: "Access high-quality online learning designed to enhance your skills and proficiency.",
//     icon: "💻",
//     link: "/",
//   },
//   {
//     title: "SOP Assistance",
//     description: "Get personalized support to draft, refine, and align your Statement of Purpose for academic applications.",
//     icon: "🧠",
//     link: "/sop",
//   },
//   {
//     title: "Visa Interview Prep",
//     description: "Prepare for your visa interview with confidence through our comprehensive preparation services.",
//     icon: "📜",
//     link: "#",
//   },
// ];

// const PopularService = ({ wrapperClass = "mt-10", styleClass = "" }) => {
//   return (
//     <Element
//       name="service"
//       className="service-area eduvibe-service-five service-wrapper-5 edu-section-gap bg-white relative flex flex-col items-center"
//     >
//       {/* Background Shape */}
//       <div className="absolute -z-10 top-0 left-1/2 transform -translate-x-1/2 opacity-30">
//         <img src="/image/shapes/shape-21.png" alt="Shape" className="w-64 h-64" />
//       </div>

//       {/* Title Section */}
//       <div className="text-center mb-8">
//         <ScrollAnimation animateIn="fadeInUp" animateOnce>
//           <h2 className="text-3xl font-bold">Popular Services</h2>
//         </ScrollAnimation>
//       </div>

//       {/* Services Grid */}
//       <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${wrapperClass} text-center mb-10`}>
//       {servicesData.map((service, index) => (
//           <div key={index} className="flex justify-center">
//             <Card className="shadow transition-shadow hover:shadow-lg cursor-pointer w-full max-w-sm">
//               <CardHeader>
//                 <div className="flex flex-col items-center space-y-2">
//                 <span className="text-[4.25rem] leading-[4.5rem]">{service.icon}</span>
//                   <div className="text-center">
//                     <CardTitle className="mt-1 text-[24px]">
//                       <a href={service.link} className="text-blue-500 hover:underline">
//                         {service.title}
//                       </a>
//                     </CardTitle>
//                     <CardDescription className="mt-5 text-[14px]">{service.description}</CardDescription>
//                   </div>
//                 </div>
//               </CardHeader>
//             </Card>
//           </div>
//         ))}
//       </div>
//     </Element>
//   );
// };

// export default PopularService;




import React from "react";
import { Element } from "react-scroll";
import ScrollAnimation from "react-animate-on-scroll";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const servicesData = [
  {
    title: "Mock Tests",
    description:
      "Prepare for exams with our comprehensive mock tests tailored for various fields.",
    icon: "📝",
    link: "/mock",
  },
  {
    title: "Career Counselling",
    description:
      "Receive expert guidance to navigate your career path, job opportunities, and career planning.",
    icon: "🎓",
    link: "/career-assessment",
  },
  {
    title: "Study Abroad Options",
    description:
      "Explore global educational opportunities with our support for studying abroad.",
    icon: "🌍",
    link: "/study-abroad",
  },
  {
    title: "E-Learning",
    description:
      "Access high-quality online learning designed to enhance your skills and proficiency.",
    icon: "💻",
    link: "/",
  },
  {
    title: "SOP Assistance",
    description:
      "Get personalized support to draft, refine, and align your Statement of Purpose for academic applications.",
    icon: "🧠",
    link: "/sop",
  },
  {
    title: "Visa Interview Prep",
    description:
      "Prepare for your visa interview with confidence through our comprehensive preparation services.",
    icon: "📜",
    link: "#",
  },
];

const PopularService = ({ wrapperClass = "mt-10" }) => {
  return (
    <Element
      name="service"
      className="service-area eduvibe-service-five service-wrapper-5 edu-section-gap bg-white relative flex flex-col items-center"
    >
      {/* Background Shape */}
      <div className="absolute -z-10 top-0 left-1/2 transform -translate-x-1/2 opacity-30">
        <img
          src="/image/shapes/shape-21.png"
          alt="Shape"
          className="w-64 h-64"
        />
      </div>

      {/* Title Section */}
      <div className="text-center mb-8">
        <ScrollAnimation animateIn="fadeInUp" animateOnce>
          <h2 className="text-3xl font-bold">Popular Services</h2>
        </ScrollAnimation>
      </div>

      {/* Services Grid */}
      <div
        className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${wrapperClass} text-center mb-10`}
      >
        {servicesData.map((service, index) => (
          <div key={index} className="flex justify-center">
            <Card className="shadow transition-shadow hover:shadow-lg w-full max-w-sm">
              <CardHeader>
                <div className="flex flex-col items-center space-y-2 text-center">
                  
                  {/* Icon with same link */}
                  <a
                    href={service.link}
                    className="hover:scale-105 transition-transform"
                  >
                    <span className="text-[4.25rem] leading-[4.5rem]">
                      {service.icon}
                    </span>
                  </a>

                  {/* Title with same link */}
                  <CardTitle className="mt-1 text-[24px]">
                    <a
                      href={service.link}
                      className="text-blue-500 hover:underline"
                    >
                      {service.title}
                    </a>
                  </CardTitle>

                  {/* Description */}
                  <CardDescription className="mt-5 text-[14px]">
                    {service.description}
                  </CardDescription>

                </div>
              </CardHeader>
            </Card>
          </div>
        ))}
      </div>
    </Element>
  );
};

export default PopularService;
